<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |</nav> -->
    <!-- <router-link to="/esercizi">Esercizi</router-link> -->
  
  <router-view/>
  <AppFooter />
  <BottomNav />
</template>
<script>
import AppFooter from '@/components/Footer.vue'
import BottomNav from '@/components/BottomNav.vue'

export default {
  components: {
    AppFooter,
    BottomNav
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
